const Globals = require("./globals");

function GetRandom(min, max) {
  return Math.random() * (max - min) + min; //The maximum is exclusive and the minimum is inclusive
}

function GetRandomInt(min, max) {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min) + min); //The maximum is exclusive and the minimum is inclusive
}

var GetObject = function (id) {
  return Globals.canvas.getObjects().find((x) => x.id === id);
};

export { GetRandom, GetRandomInt, GetObject };
